import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatToast } from '@blocks-react/components/Toast';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import cx from 'classnames';
import styles from './ContactUsFormNotification.module.scss';
import { VARIANTS_MESSAGE_NOTIFICATION } from './../../constants';

const ContactUsFormNotification = ({ close, variant, heading, body = '' }) => {
  return (
    <div
      className={cx({
        'py-3 py-lg-4 my-3': variant === VARIANTS_MESSAGE_NOTIFICATION.ERROR,
        'pt-3 pt-lg-3 mb-3 mb-lg-4':
          variant === VARIANTS_MESSAGE_NOTIFICATION.SUCCESS
      })}
    >
      {variant === VARIANTS_MESSAGE_NOTIFICATION.ERROR ? (
        <CatInlineNotification
          heading={heading}
          variant="error"
          dismissible
          close={close}
        >
          <CatIconWarningCircle slot="before" />
          {body}
        </CatInlineNotification>
      ) : (
        <CatToastGroup
          verticalPosition="top"
          horizontalPosition="right"
          isInline
          style={{
            '--cat-group-toast--inset-block-start': '1',
            '--rtlTranslateX': '0'
          }}
        >
          <Fragment key=".0">
            <CatToast
              className={styles['toast-sm-width']}
              variant="success"
              close={close}
            >
              <CatIconSuccess slot="before" />
              <CatHeading variant="label-sm">{heading}</CatHeading>
            </CatToast>
          </Fragment>
        </CatToastGroup>
      )}
    </div>
  );
};

ContactUsFormNotification.propTypes = {
  variant: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string,
  close: PropTypes.func
};

export default ContactUsFormNotification;
